import { Col, Divider, Row, Radio, message, Input } from "antd";
import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";
import CustomSelect from "../../Components/CustomSelect";
import { SectionCardWrapper } from "../../Components/UI/SectionCardWrapper";
import {
  Agent_optiom,
  CustomLabel,
  DEA_RENEWAL_QUICKPAY_CONSTANT,
  error_message,
  format_amount,
  getURlParameter,
  payment_option,
  // payment_option_only_asba,
  payment_option_with_upi,
  reason_for_quickpay,
  regex,
  TYPE_OF_VALIDATION,
  validationOfField,
} from "../../Constant";
import { RESET_RESPONSE_POLICY } from "../../Redux/ErrorResponse/types";
import {
  GET_POLICY_DETAILS,
  GET_POLICY_INVOKE,
  Payload_entry,
  SAVE_PAYMENT,
  SET_UPI_ASBA_FLAG,
} from "../../Redux/PolicyNumber/types";
import { postApi, getApi } from "../../Services/apiService";
import { GET_POLICY, SAVE_PAYMENT_DETAILS, IS_BLOCK_POLICY, GET_POLICY_PAYMENT } from "../../Services/endpoints";
import FooterButton from "../Footer";
import InputFormComponent from "./InputFormComponent";
import { decrypt, encrypt } from "../../Services/AESEncryptionDecryption";
import "./style.css";
import { useCaptcha } from "../../Utils/recaptcha";
const STATIC_DATA = {
  New_Application: "New Business",
  Agent_Recruitment: "Agent Recruitment",
  Renewal: "Renewal",
  UPI_ASBA: "UPI ASBA"
};

let agent_details_data = {
  proposalType: STATIC_DATA.Agent_Recruitment,
  paymentFor: "Agent Recruitment Fee",
  policyNumber: null,
  proposalNumber: "",
  amount: 627.0,
};

const QuickPay = ({ isCampaign = false }) => {
  const renewalBaseUrl = process.env.REACT_APP_RENEWAL_URL;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const userDBData = useSelector((state) => state.policyDetails);
  const [isPaymentFirst, setIsPaymentFirst] = useState(false);
  const [applicationType, setApplicationType] = useState("New Business");
  const [disableProposalType, setDisableProposalType] = useState(false);
  const [reason, setReason] = useState("");
  const [paymentSelect, setPaymentSelect] = useState(null);
  const [showProceedBtn, setShowProceedBtn] = useState(true);
  const [saveDetails, setSaveDetails] = useState(true);
  const [comment, setComment] = useState("");
  const [isQuoteFlow, setIsQuoteFlow] = useState(false);
  const [reason_error, setReason_error] = useState(false);
  const [disableField, setDisableField] = useState({
    PoNum: false,
    amount: false,
    comments: false,
    reason: false,
    payFor: false,
    name: false,
  });
  const [error, setError] = useState({
    PoNumError: false,
    amountError: false,
    nameError: false,
    mobileError: false,
    emailError: false,
    agentNoError: false,
  });
  const [userData, setUserData] = useState({
    PoNum: "",
    amount: null,
    name: "",
    mobile: "",
    email: "",
    agentNo: "",
  });

  const { PoNum, amount, name, mobile, email, agentNo } = userData;
  const {
    PoNumError,
    amountError,
    nameError,
    mobileError,
    emailError,
    agentNoError,
  } = error;

  const {
    nextPremiumDueDt,
    nextInstalmentAmt,
    premiumToBeCollected,
    paymentFrequencyCd,
    baseAgentId,
    receiptBranchId,
    partyAddressSeq,
    priority,
    contactTypeCd,
    contactNum,
    extensionNum,
    stdCode,
    preferredFl,
    emailTypeCd,
    statusCd,
    firstName,
    lastName,
    emailAddress,
    getPolicyHit,
  } = userDBData;

  const commmonObj = { PoNum, amount };
  const premiumObj = { PoNum, name, email, mobile };
  const installmentObj = { PoNum };
  const AgentObj = { agentNo };
  const commmonObjError = { PoNumError, amountError };
  const premiumObjError = {
    PoNumError,
    amountError,
    nameError,
    emailError,
    mobileError,
  };
  const installmentObjError = { PoNumError };
  const AgentObjError = { agentNoError };
  const { New_Application, Agent_Recruitment, Renewal, UPI_ASBA } = STATIC_DATA;
  const { handleReCaptchaVerify, captchaToken } = useCaptcha();
  const [bypassCalled, setBypassCalled] = useState(false);
  const isUpiAsba = applicationType === UPI_ASBA || paymentSelect === "UPI_ASBA"
  const onAPiCall = async () => {
    const newToken = await handleReCaptchaVerify();
    if (applicationType === Renewal && !isCampaign) {
      try {
        const response = await getApi(`${IS_BLOCK_POLICY}?pno=${PoNum}`, { baseURL: renewalBaseUrl });
        if (response?.data?.response) {
          message.error(`We are unable to retrieve your policy details, please get in touch with distributor/branch.`);
          return;
        }
      }
      catch (err) {
        message.error(error_message?.common_error);
      }
    }

    if (applicationType === Renewal && paymentSelect === payment_option[0].value) {
      const demoObj = {
        token: newToken,
        listofPolicyDetailsTO: [
          {
            policyNum: `${applicationType === Renewal ? PoNum : ""}`,
            applicationID: `${applicationType !== Renewal ? PoNum : ""}`,
          },
        ],
      };

      if (reason.length === 0 || comment.length === 0) {
        return setReason_error(true);
      } else {
        setReason_error(false);
        try {
          const encryptedObj = encrypt(JSON?.stringify(demoObj))
          const response = await postApi(GET_POLICY, {
            encodedString: encryptedObj
          });
          if (response?.data?.response) {
            const decryptedRes = JSON?.parse(decrypt(response?.data?.response))
            await dispatch({
              type: GET_POLICY_DETAILS,
              payload: decryptedRes,
            });
            await dispatch({ type: GET_POLICY_INVOKE, payload: true });
            await savePaymentDetails(amount);
          } else {
            message.error(response?.data?.error?.errorMessage);
          }
        } catch (err) {
          message.error(err?.errorMessage ?? "Something went wrong")
        }
      }
      return;
    }
    if (applicationType === Agent_Recruitment) {
      agent_details_data.policyNumber = agentNo;
      await dispatch({ type: GET_POLICY_INVOKE, payload: true });
      await dispatch({ type: SAVE_PAYMENT, payload: agent_details_data });
      savePaymentDetails(amount);
      return;
    }

    if (
      applicationType === New_Application &&
      paymentSelect == payment_option[0].value && !isPaymentFirst
    ) {
      return checkNSTPFlag();
    }

    const data = {
      token: newToken,
      listofPolicyDetailsTO: [
        {
          policyNum: `${applicationType === Renewal ? PoNum : ""}`,
          applicationID: `${applicationType !== Renewal ? PoNum : ""}`,
        },
      ],
    };

    try {
      const encryptedObj = encrypt(JSON?.stringify(data))
      const response = await postApi(GET_POLICY, {
        encodedString: encryptedObj
      });
      if (response?.data?.response) {
        const decryptedRes = JSON?.parse(decrypt(response?.data?.response))
        dispatch({
          type: GET_POLICY_DETAILS,
          payload: decryptedRes,
        });
        dispatch({ type: GET_POLICY_INVOKE, payload: true });
        if (isUpiAsba && decryptedRes?.statusCd?.toString()?.toLowerCase() !== "pending") {
          message?.error("ASBA registration can only be done for Pending policies.")
        }
      }
      else {
        message.error(response?.data?.error?.errorMessage);
      }
    } catch (err) {
      if ((isCampaign || isPaymentFirst) && applicationType === New_Application) {
        dispatch({ type: Payload_entry, payload: { name: name } });
        savePaymentDetails(amount)
      }
      else {
        message.error(err?.errorMessage ?? "Something went wrong")
      }
    }
  };

  const checkNSTPFlag = async () => {
    const newToken = await handleReCaptchaVerify();
    const data = {
      token: newToken,
      listofPolicyDetailsTO: [
        {
          policyNum: `${applicationType === Renewal ? PoNum : ""}`,
          applicationID: `${applicationType !== Renewal ? PoNum : ""}`,
        },
      ],
    };

    try {
      const encryptedObj = encrypt(JSON?.stringify(data));
      const response = await postApi(GET_POLICY_PAYMENT, {
        encodedString: encryptedObj,
      });
      if (response?.data?.response) {
        const decryptedRes = JSON?.parse(decrypt(response?.data?.response))
        if (decryptedRes?.proccedToPayment === "Yes" || isCampaign) {
          dispatch({ type: Payload_entry, payload: { name: name } });
          return savePaymentDetails(decryptedRes?.premiumToBeCollected);
        }
        else {
          message?.error(decryptedRes?.message)
        }
      } else {
        message.error(response?.data?.error?.errorMessage || error_message?.common_error);
      }
    } catch (err) {
      message.error(err?.errorMessage || error_message?.common_error);
    }
  }

  const savePaymentDetails = async (amount) => {
    const newToken = await handleReCaptchaVerify();
    let amt = amount ?? 0;
    const obj = {
      policyNo: PoNum.trim(),
      amount: amt.toString().trim(),
    };

    if (applicationType === Agent_Recruitment) {
      obj.policyNo = agentNo;
      obj.amount = 627;
    }
    const responseObject = {
      proposalType: applicationType,
      paymentFor: paymentSelect,
      policyNumber: `${(applicationType !== New_Application && applicationType !== UPI_ASBA) ? obj.policyNo : ""
        }`,
      proposalNumber: `${(applicationType === New_Application || applicationType === UPI_ASBA) ? obj.policyNo : ""
        }`,
      amount: obj.amount
        ? parseFloat(obj.amount)
        : parseFloat((applicationType === UPI_ASBA || paymentSelect === "UPI_ASBA") ? premiumToBeCollected : nextInstalmentAmt),
      source: "MCHI",
      nextPremiumDueDt,
      nextInstalmentAmt,
      paymentFrequencyCd,
      baseAgentId,
      receiptBranchId,
      partyAddressSeq,
      priority,
      contactTypeCd: contactTypeCd ?? "MOBILE",
      contactNum: contactNum ?? mobile.trim(),
      extensionNum,
      stdCode,
      preferredFl,
      emailTypeCd: emailTypeCd ?? "PERSONAL",
      emailAddress: emailAddress ?? email.trim(),
      reasonOfQuickpay: reason,
      comments: comment,
      token: newToken
    };

    // dispatch({ type: SAVE_PAYMENT, payload: save_details_data });
    // return navigate("/summary");

    try {
      const encryptedObj = encrypt(JSON?.stringify(responseObject))
      const res = await postApi(SAVE_PAYMENT_DETAILS, {
        encodedString: encryptedObj
      });
      const saveAmount = (applicationType === UPI_ASBA || (paymentSelect === "UPI_ASBA")) ? premiumToBeCollected : nextInstalmentAmt;
      if (res?.data?.response) {
        const decryptedRes = JSON.parse(decrypt(res?.data?.response))
        if (decryptedRes?.id) {
          if (
            !decryptedRes?.nextPremiumDueDt &&
            decryptedRes?.paymentFor === "Instalment"
          ) {
            return message.error(
              "You are not currently eligible for Installment payment"
            );
          }
          if (applicationType !== Agent_Recruitment) {
            dispatch({
              type: SAVE_PAYMENT,
              payload: {
                ...decryptedRes,
                amount: !!amount ? amount : saveAmount,
              },
            });
          }
          //SETTING ASBA FLAG
          dispatch({ type: SET_UPI_ASBA_FLAG, payload: isUpiAsba });
          //Navigate to summary
          navigate("/summary");
        }
      }
      else {
        message.error(res?.data?.error?.errorMessage);
      }
    } catch (err) {

    }
  };

  useEffect(() => {
    switch (applicationType) {
      case New_Application:
      case UPI_ASBA:
      case Renewal:
        if (
          paymentSelect === payment_option[1].value ||
          paymentSelect === payment_option[2].value
        ) {
          return validationOFEveryField(commmonObj, commmonObjError);
        } else if (paymentSelect === payment_option[0].value || paymentSelect === "UPI_ASBA") {
          if (applicationType === Renewal) {
            return validationOFEveryField(commmonObj, commmonObjError);
          }
          return validationOFEveryField(premiumObj, premiumObjError);
        } else {
          return validationOFEveryField(installmentObj, installmentObjError);
        }
      case Agent_Recruitment:
        return validationOFEveryField(AgentObj, AgentObjError);
    }
  }, [userData, error, paymentSelect]);

  const validationOFEveryField = (fieldObj, errorObj) => {
    return setShowProceedBtn(
      Object.values(fieldObj).some((ei) => ei === "") ||
      Object.values(errorObj).some((ei) => ei === true)
    );
  };

  useEffect(() => {
    const query = getURlParameter("q") ? JSON.parse(decrypt(getURlParameter("q"))) : "";
    if (!getURlParameter("paytype") && !query?.quote) {
      setPaymentSelect(getPaymentOption()[0]?.value);
      setUserData({
        PoNum: "",
        amount: "",
        name: "",
        mobile: "",
        email: "",
        agentNo: "",
      });
      setError({
        PoNumError: false,
        amountError: false,
        nameError: false,
        mobileError: false,
        emailError: false,
        agentNoError: false,
      });
    }
  }, [applicationType]);


  useEffect(() => {
    dispatch({ type: RESET_RESPONSE_POLICY });
    setPaymentSelect(getPaymentOption()[0]?.value);
    checkDefaultParams();
    if (
      getURlParameter("pno") &&
      getURlParameter("protype") &&
      getURlParameter("paytype")
    ) {
      document.body.classList.add("loading-indicator-api");
    }
    return () => {
      dispatch({ type: GET_POLICY_INVOKE, payload: false });
    };
  }, []);

  const checkDefaultParams = () => {
    if (getURlParameter("q")) {
      const query = getURlParameter("q");
      const decryptText = decrypt(query);
      const parsedData = JSON.parse(decryptText);
      if (parsedData?.quote) {
        const appNo = parsedData?.pno;
        const premiumAmount = parsedData?.amount;
        setIsQuoteFlow(true);
        setUserData({
          ...userData,
          PoNum: appNo || "",
          amount: premiumAmount || "",
        });
        setDisableField({
          ...disableField,
          PoNum: true,
          amount: true,
          comments: true,
          reason: true,
          payFor: true,
        });
        setApplicationType(STATIC_DATA?.Renewal);
        setPaymentSelect(getPaymentOption()[0]?.value);
        setReason(DEA_RENEWAL_QUICKPAY_CONSTANT);
        setComment(parsedData?.quote);
        setDisableProposalType(true);
        if (appNo) {
          setError({
            ...error,
            PoNumError: validatePOlicyNumber(appNo, STATIC_DATA?.Renewal),
          });
        }
      } else if (parsedData?.type) {
        const proposalType = parsedData?.type;
        const appNo = parsedData?.application_no;
        const premiumAmount = parsedData?.amount;
        const name = parsedData?.name;
        setDisableField({
          ...disableField,
          PoNum: true,
          amount: true,
        });
        if (proposalType) {
          switch (proposalType) {
            case "NB":
              setApplicationType(STATIC_DATA?.New_Application);
              setDisableProposalType(true);
              setIsPaymentFirst(true);
              break;
            case "RN":
              setApplicationType(STATIC_DATA?.Renewal);
              setDisableProposalType(true);
              break;
            case "AR":
              setApplicationType(STATIC_DATA?.Agent_Recruitment);
              setDisableProposalType(true);
              break;
            default:
              setApplicationType(STATIC_DATA?.New_Application);
              setDisableProposalType(true);
              break;
          }
        }
        if (appNo || premiumAmount) {
          setError({
            ...error,
            PoNumError: validatePOlicyNumber(appNo),
          });
          setUserData({
            ...userData,
            PoNum: appNo || "",
            amount: premiumAmount || "",
            name: name || "",
          });
        }
      }
    }
  };
  const byPassApiCall = async () => {
    setBypassCalled(true);
    let proposalType = getURlParameter("protype") || "";
    proposalType = proposalType.trim().replace("%20", " ");
    let pno = getURlParameter("pno") || "";
    let paymentType = getURlParameter("paytype") || "";
    // let amt = getURlParameter("payamt") || "";
    setApplicationType(proposalType);
    setPaymentSelect(paymentType);
    setUserData({
      ...userData,
      ...{ PoNum: pno },
    });
    if (proposalType === Renewal && !isCampaign) {
      try {
        const response = await getApi(`${IS_BLOCK_POLICY}?pno=${pno}`, { baseURL: renewalBaseUrl });
        if (response?.data?.response) {
          message.error(`We are unable to retrieve your policy details, please get in touch with distributor/branch.`);
          return;
        }
      }
      catch (err) {
        message.error(error_message?.common_error);
      }
    }
    const data = {
      token: captchaToken,
      listofPolicyDetailsTO: [
        {
          policyNum: `${proposalType === Renewal ? pno : ""}`,
          applicationID: `${proposalType !== Renewal ? pno : ""}`,
        },
      ],
    };

    try {
      const encryptedObj = encrypt(JSON?.stringify(data))
      const response = await postApi(GET_POLICY, {
        encodedString: encryptedObj
      });
      if (response?.data?.response) {
        const decryptedRes = JSON?.parse(decrypt(response?.data?.response))
        dispatch({ type: GET_POLICY_INVOKE, payload: true });
        dispatch({
          type: GET_POLICY_DETAILS,
          payload: decryptedRes,
        });
      } else {
        message.error(response?.data?.error?.errorMessage);
      }
    }
    catch (err) {
      message.error(err?.errorMessage ?? "Something went wrong")
    }
  };

  const validatePOlicyNumber = (value, appType = applicationType) => {
    const lengthCheck = (appType === New_Application || appType === UPI_ASBA) ? 10 : 15;
    return !(value.length === lengthCheck);
  };

  useEffect(() => {
    if (Object.keys(userDBData).length > 5 && getPolicyHit && saveDetails) {
      setSaveDetails(false);
      const isBlockAsba = isUpiAsba && statusCd?.toString()?.toLowerCase() !== "pending"
      if (!isBlockAsba && !isQuoteFlow) {
        savePaymentDetails(amount);
      }
    }
  }, [userDBData]);

  useEffect(() => {
    if (
      !bypassCalled &&
      captchaToken &&
      getURlParameter("pno") &&
      getURlParameter("protype") &&
      getURlParameter("paytype")
    ) {
      byPassApiCall();
    }
  }, [captchaToken])

  const getAmountField = () => {
    if ((applicationType === New_Application || applicationType === UPI_ASBA) && (paymentSelect === payment_option[0]?.value || paymentSelect === "UPI_ASBA")) {
      return null;
    }
    else if (applicationType !== Agent_Recruitment && paymentSelect !== payment_option[3].value) {
      return (
        <InputFormComponent
          label={"Amount"}
          className="user-input"
          name="Proposer's Name"
          placeholder="000000"
          value={amount}
          disabled={disableField?.amount}
          regex={regex.decimal_only}
          onChange={(e) =>
            setUserData({
              ...userData,
              ...{ amount: format_amount(e.target.value) },
            })
          }
        />
      )
    }
    else {
      return null;
    }
  }
  const getPaymentOption = () => {
    if (isCampaign) {
      return applicationType !== Agent_Recruitment
        ? payment_option
        : Agent_optiom;
    }
    // else if (applicationType === UPI_ASBA) {
    //   return payment_option_only_asba;
    // } 
    else if (applicationType === New_Application) {
      return payment_option_with_upi;
    } else {
      return applicationType !== Agent_Recruitment
        ? payment_option
        : Agent_optiom;
    }
  };
  return (
    <div className="container">
      <Row justify="space-around" className={"cls_row_b97d89"}>
        <Col lg={15} md={20} xs={24}>
          <SectionCardWrapper>
            <div className="payment-header">
              <CustomLabel font_size="24">Make Payment</CustomLabel>
            </div>
            <div>
              <Row justify="space-between">
                <Col span={10}>
                  <CustomLabel>Proposal Type</CustomLabel>
                </Col>
                <Col lg={10} md={12} xs={12}>
                  <Radio.Group
                    onChange={(e) => setApplicationType(e.target.value)}
                    value={applicationType}
                  >
                    <Radio
                      disabled={
                        disableProposalType &&
                        applicationType !== New_Application
                      }
                      value={New_Application}
                    >
                      New Business{" "}
                    </Radio>
                    <Radio
                      disabled={
                        disableProposalType && applicationType !== Renewal
                      }
                      value={Renewal}
                    >
                      Renewal
                    </Radio>
                    <Radio
                      disabled={
                        disableProposalType &&
                        applicationType !== Agent_Recruitment
                      }
                      value={Agent_Recruitment}
                    >
                      Agent Recruitment
                    </Radio>
                    {/* {!isCampaign ? <Radio
                      disabled={
                        disableProposalType &&
                        applicationType !== UPI_ASBA
                      }
                      value={UPI_ASBA}
                    >
                      {"UPI - ASBA"}
                    </Radio> : null} */}
                  </Radio.Group>
                </Col>
                <Divider />
              </Row>
            </div>
            <div className={"cls_mghuntqu_1b1e61"}>
              <Row justify="space-between">
                <Col span={10}>
                  <CustomLabel>Payment for</CustomLabel>
                </Col>
                <Col lg={10} md={12} xs={12}>
                  <CustomSelect
                    selectOption={getPaymentOption()}
                    placeholder="Select From Below Option"
                    onSelectClick={(e) => {
                      setPaymentSelect(e);
                    }}
                    value={paymentSelect}
                    disabled={disableField?.payFor}
                  />
                </Col>
                <Divider />
              </Row>
            </div>
            {applicationType === Agent_Recruitment && (
              <InputFormComponent
                label={"Agent Recruitment Form Number"}
                className="user-input"
                name="Agent Recruitment Form Number"
                value={agentNo}
                regex={regex.numeric_only}
                maxlength={12}
                error={error.agentNoError}
                msg={"Enter valid Agent Number"}
                placeholder="12********65"
                onChange={(e) => {
                  setError({
                    ...error,
                    ...{
                      agentNoError: validationOfField(
                        TYPE_OF_VALIDATION.AgenNo,
                        e.target.value
                      ),
                    },
                  });
                  return setUserData({
                    ...userData,
                    ...{ agentNo: e.target.value },
                  });
                }}
              />
            )}

            {applicationType === Renewal &&
              paymentSelect === payment_option[0].value && (
                <div className={"cls_mghuntqv_12a4ed"}>
                  <Row justify="space-between">
                    <Col span={10}>
                      <CustomLabel>
                        Reason for Quickpay{" "}
                        <span className={"cls_mghuntqv_957bfe"}>*</span>{" "}
                      </CustomLabel>
                    </Col>
                    <Col
                      lg={10}
                      md={12}
                      xs={12}
                      className={"cls_mghuntqv_65de56"}
                    >
                      <CustomSelect
                        // mode={"tags"}
                        // maxTagCount={"responsive"}
                        selectOption={reason_for_quickpay}
                        placeholder="Select From Below Option"
                        onSelectClick={(e) => {
                          setReason(e);
                        }}
                        disabled={disableField?.reason}
                        value={reason}
                      />
                      {reason_error && reason.length === 0 && (
                        <div className={"cls_mghuntqv_6b32e3"}>
                          {" "}
                          <label className={"cls_mghuntqv_b28e7c"}>
                            {"Select one of the reason"}
                          </label>
                        </div>
                      )}
                    </Col>
                    <Divider />
                  </Row>
                </div>
              )}

            {applicationType === Renewal &&
              paymentSelect === payment_option[0].value && (
                <div className={"cls_mghuntqv_b77ed4"}>
                  <Row justify="space-between">
                    <Col span={10}>
                      <CustomLabel>
                        Comment <span className={"cls_mghuntqv_d4627c"}>*</span>{" "}
                      </CustomLabel>
                    </Col>
                    <Col
                      lg={10}
                      md={12}
                      xs={12}
                      className={"cls_mghuntqv_1f8278"}
                    >
                      <Input.TextArea
                        maxLength={300}
                        showCount
                        placeholder="Enter your reason"
                        value={comment}
                        disabled={disableField?.comments}
                        onChange={(e) => {
                          setComment(e.target.value);
                        }}
                        className={"cls_mghuntqv_e08350"}
                      />
                      {reason_error && comment.length === 0 && (
                        <div className={"cls_mghuntqv_05b2a4"}>
                          {" "}
                          <label className={"cls_mghuntqv_a268fe"}>
                            {" Please Enter Comment"}
                          </label>
                        </div>
                      )}
                    </Col>
                    <Divider />
                  </Row>
                </div>
              )}

            {applicationType !== Agent_Recruitment && (
              <InputFormComponent
                label={
                  applicationType === Renewal
                    ? "Policy number"
                    : "Proposal number"
                }
                className="user-input"
                name="Proposer's Name"
                value={PoNum}
                disabled={disableField?.PoNum}
                placeholder="12********65"
                error={error.PoNumError}
                msg={
                  applicationType === Renewal
                    ? "Enter valid Policy Number"
                    : "Enter valid Proposal Number"
                }
                maxlength={(applicationType === New_Application || applicationType === UPI_ASBA) ? 10 : 15}
                onChange={(e) => {
                  setError({
                    ...error,
                    PoNumError: validatePOlicyNumber(e.target.value),
                  });
                  return setUserData({
                    ...userData,
                    ...{ PoNum: e.target.value },
                  });
                }}
              />
            )}
            {getAmountField()}
            {(paymentSelect === payment_option[0].value || paymentSelect === "UPI_ASBA") &&
              (applicationType === New_Application || applicationType === UPI_ASBA) && (
                <>
                  {
                    <InputFormComponent
                      label={"Proposer's Name"}
                      className="user-input"
                      name="Proposer's Name"
                      placeholder="Name"
                      regex={regex.name}
                      value={name}
                      onChange={(e) =>
                        setUserData({
                          ...userData,
                          ...{ name: e.target.value },
                        })
                      }
                    />
                  }
                  {
                    <InputFormComponent
                      label={"Mobile Number of payer"}
                      className="user-input"
                      name="Mobile"
                      placeholder="****45***"
                      value={mobile}
                      error={error.mobileError}
                      maxlength={10}
                      msg={"Enter valid Phone Number"}
                      regex={regex.numeric_only}
                      onChange={(e) => {
                        setError({
                          ...error,
                          ...{
                            mobileError: validationOfField(
                              TYPE_OF_VALIDATION.Mobile,
                              e.target.value
                            ),
                          },
                        });
                        return setUserData({
                          ...userData,
                          ...{ mobile: e.target.value },
                        });
                      }}
                    />
                  }
                  {
                    <InputFormComponent
                      label={"Email ID of payer"}
                      className="user-input"
                      name="Email"
                      value={email}
                      error={error.emailError}
                      maxlength={60}
                      msg={"Enter valid Email Address"}
                      regex={regex.common}
                      placeholder="****@gmail.com"
                      onChange={(e) => {
                        setError({
                          ...error,
                          ...{
                            emailError: validationOfField(
                              TYPE_OF_VALIDATION.email,
                              e.target.value
                            ),
                          },
                        });
                        return setUserData({
                          ...userData,
                          ...{ email: e.target.value },
                        });
                      }}
                    />
                  }
                </>
              )}
            <div>
              <FooterButton
                hideBack={true}
                nextLabel="Proceed"
                onNext={onAPiCall}
                disableNext={showProceedBtn}
              />
            </div>
          </SectionCardWrapper>
        </Col>
      </Row>
    </div>
  );
};

export default QuickPay;